import React, { useState } from 'react'
import { Manager, Reference, Popper } from 'react-popper'

import { useStyles } from './generic-dropdown.style'

export const MENU_TYPE = {
  DEFAULT: 'default',
  SMALL: 'small'
}

export const GenericDropdown = function ({ DropdownItems, Target, placement = 'bottom-start', dropdownOffset = '0px, 0px', menuType = MENU_TYPE.DEFAULT }) {
  const classes = useStyles()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <>
      {isDropdownOpen &&
        <div className={classes.overlay} onClick={() => { setIsDropdownOpen(false) }}></div>
      }
      <Manager>
        <Reference>
          {({ ref }) => (
            <div ref={ref} onClick={() => { setIsDropdownOpen(true) }}>
              {Target}
            </div>
          )}
        </Reference>
        {isDropdownOpen &&
          <Popper placement={placement} modifiers={{
            offset: {
              offset: dropdownOffset
            }
          }}>
            {({ ref, style, placement }) => (
              <div ref={ref} style={style} data-placement={placement} className={menuType === MENU_TYPE.SMALL ? classes.menuSmall : classes.menu }>
                {DropdownItems.map(({ key, props }) => {
                  const { onClick } = props
                  return (
                    <a key={key} data-qa="dropdown-selection" {...props} onClick={(event) => {
                      setIsDropdownOpen(false)
                      onClick(event)
                    }} />)
                })}
              </div>
            )}
          </Popper>
        }
      </Manager>
    </>
  )
}
